export class FormFieldVisibilityManager {
  constructor(initialVisibilityConfig = {}) {
    this.visibilityConfig = {
      // Basic Info Fields
      mobile: true,
      name: true,
      gender: true,
      age: true,
      email: true,
      address: true,
      uhid: true,
      importId: true,
      patientNumber: true,

      // More Details Fields
      language: true,
      city: true,
      pincode: true,
      note: true,
      attendants: true,
      communicationToAttendant: true,
      alternativeMobiles: true,
      alternativeEmails: true,
      referredBy: true,

      // Conditional Fields
      relationDropdown: false,
      anonymousPatientCheckbox: true,

      // Entire Sections
      moreDetailsSection: true,

      ...initialVisibilityConfig
    }
  }

  isFieldVisible(fieldName) {
    return this.visibilityConfig[fieldName] !== false
  }

  hideField(fieldName) {
    this.visibilityConfig[fieldName] = false
    return this
  }

  showField(fieldName) {
    this.visibilityConfig[fieldName] = true
    return this
  }

  hideFields(fieldNames) {
    fieldNames.forEach(fieldName => {
      this.visibilityConfig[fieldName] = false
    })
    return this
  }

  showFields(fieldNames) {
    fieldNames.forEach(fieldName => {
      this.visibilityConfig[fieldName] = true
    })
    return this
  }

  hideBasicInfoFields() {
    const basicFields = ['mobile', 'name', 'gender', 'age', 'email', 'alternativeEmails', 'address']
    return this.hideFields(basicFields)
  }

  showBasicInfoFields() {
    const basicFields = ['mobile', 'name', 'gender', 'age', 'email', 'alternativeEmails', 'address']
    return this.showFields(basicFields)
  }

  hideMoreDetailsFields() {
    const moreDetailsFields = [
      'language', 'city', 'pincode', 'note', 'attendants',
      'communicationToAttendant', 'alternativeMobiles', 'alternativeEmails', 'referredBy'
    ]
    return this.hideFields(moreDetailsFields)
  }

  showMoreDetailsFields() {
    const moreDetailsFields = [
      'language', 'city', 'pincode', 'note', 'attendants',
      'communicationToAttendant', 'alternativeMobiles', 'alternativeEmails', 'referredBy'
    ]
    return this.showFields(moreDetailsFields)
  }

  hideOptionalFields() {
    const optionalFields = ['address', 'uhid', 'importId', 'note', 'referredBy', 'alternativeMobiles', 'alternativeEmails']
    return this.hideFields(optionalFields)
  }

  showOptionalFields() {
    const optionalFields = ['address', 'uhid', 'importId', 'note', 'referredBy', 'alternativeMobiles', 'alternativeEmails']
    return this.showFields(optionalFields)
  }

  setConditionalVisibility(fieldName, conditionFn, dependencies) {
    this.conditionalFields = this.conditionalFields || {}
    this.conditionalFields[fieldName] = {
      conditionFn,
      dependencies
    }
    return this
  }

  updateConditionalVisibility(patientDetails, formState) {
    if (!this.conditionalFields) return

    Object.entries(this.conditionalFields).forEach(([fieldName, config]) => {
      const shouldShow = config.conditionFn(patientDetails, formState)
      this.visibilityConfig[fieldName] = shouldShow
    })
  }

  getVisibleFields() {
    return Object.keys(this.visibilityConfig).filter(
      fieldName => this.visibilityConfig[fieldName]
    )
  }

  getHiddenFields() {
    return Object.keys(this.visibilityConfig).filter(
      fieldName => !this.visibilityConfig[fieldName]
    )
  }

  reset() {
    Object.keys(this.visibilityConfig).forEach(fieldName => {
      this.visibilityConfig[fieldName] = true
    })
    return this
  }

  getConfig() {
    return { ...this.visibilityConfig }
  }

  updateConfig(newConfig) {
    this.visibilityConfig = { ...this.visibilityConfig, ...newConfig }
    return this
  }
}

export default FormFieldVisibilityManager
